var map = {
	"./american_football.png": "8911",
	"./badminton.png": "5dd0",
	"./baseball.png": "009d",
	"./cricket.png": "8f90",
	"./csgo.png": "0a06",
	"./dota2.png": "1866",
	"./ice_hockey.png": "94bc",
	"./kog.png": "c3aa",
	"./logo.png": "cf05",
	"./lol.png": "7c91",
	"./olympics.png": "4965",
	"./snooker.png": "e780",
	"./table_tennis.png": "612e",
	"./volleyball.png": "fa32"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";